export enum Locales {
  SR = 'sr',
  EN = 'en',
}

export const LOCALES = [
  { value: Locales.SR, caption: 'Srpski' },
  { value: Locales.EN, caption: 'English' },
]